import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-screen h-screen fixed z-50 flex flex-col items-center justify-center bg-black/50"
}
const _hoisted_2 = { class: "bg-white w-content h-content px-6 rounded flex flex-col items-center gap-4" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-end items-end px-6 py-4 w-full xs:mt-8 lg:mt-0"
}
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col w-full h-full items-center justify-around"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-semibold" }, "Finalizando", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/LogoIcon.svg",
  class: "animate-loading-spin w-20"
}, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "flex flex-col items-center justify-center xs:w-72 md:w-96" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "font-semibold text-3xl mb-10" }, "Algo deu errado!", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "shadow shadow-vermelho-lixeira w-full bg-vermelho-lixeira text-white text-center text-xl p-2 mb-4 rounded" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "" }, " Infelizmente não fomos capazes de completar seu pagamento :( "),
  /*#__PURE__*/_createElementVNode("p", { class: "" }, "Tente novamente mais tarde")
], -1)
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { class: "flex flex-col items-center justify-center xs:w-72 md:w-96" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "font-semibold text-2xl mb-10 text-center" }, " Compra realizada com sucesso! ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ModalPix = _resolveComponent("ModalPix")!

  return (_ctx.show != 'waiting')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.show != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }, [
                  _createVNode(_component_Icon, {
                    icon: "teenyicons:x-solid",
                    class: "text-cinza-padrao hover:cursor-pointer"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.show == 'pix')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_ModalPix, {
                  regenerate: _ctx.regenerate,
                  restartingQR: _ctx.restartingQR
                }, null, 8, ["regenerate", "restartingQR"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.show == 'error')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Icon, {
                    icon: "zondicons:exclamation-outline",
                    class: "text-9xl text-vermelho-lixeira mb-10"
                  }),
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("p", _hoisted_13, " Erro: " + _toDisplayString(_ctx.errorMessage ?? ' Sem detalhes'), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.show == 'success')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_Icon, {
                    icon: "lets-icons:check-fill",
                    class: "text-9xl text-green-600 mb-10"
                  }),
                  _hoisted_16
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}